import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { CloudStore } from "@omni/types/api/store/cloud/store.model";

export const $ProductDetailModuleName = "productDetail";

export type TProductDetailState = {
    deliveryType: DeliveryType;
    shop: CloudStore | null;
    quantity: number;
    sku: string;
    stickyOrderButton: boolean;
    serviceProductSkus?: string[];
};
